usersModule.factory('usersHierarchyService',
    ['AppSettings', 'userAuthenticateService', 'commonRESTCallService',
    function (AppSettings, userAuthenticateService, commonRESTCallService) {
        var usersAPI = {};
        var myURL = AppSettings.startIdentitySvcURL + 'providers/';
        var myURLDealerships =  AppSettings.startIdentitySvcURL + 'dealerships/';
        var myToken = '';

        //get all divisions per logged in provider
        usersAPI.getProviderDivisions = function (providerId) {
            var urlGet = myURL + providerId + '/hierarchylevels/DIVISION/0/hierarchyleafs/';
            myToken = userAuthenticateService.getUserToken();
            return commonRESTCallService.getFromServerWithToken(
                urlGet, myToken
            );
        };

        //get all regions per selected Division
        usersAPI.getRegionsByDivision = function (providerId, divisionId) {
            var urlGet = myURL + providerId + '/hierarchylevels/REGIONS/' + divisionId + '/hierarchyleafs/';
            myToken = userAuthenticateService.getUserToken();
            return commonRESTCallService.getFromServerWithToken(
                urlGet, myToken
            );
        };

        //get all regions per selected Division
        usersAPI.getDistrictsByRegion = function (providerId, regionId) {
            var urlGet = myURL + providerId + '/hierarchylevels/DISTRICTS/' + regionId + '/hierarchyleafs/';
            myToken = userAuthenticateService.getUserToken();
            return commonRESTCallService.getFromServerWithToken(
                urlGet, myToken
            );
        };

        //get all regions per selected Division
        usersAPI.getGroupsByDistrict = function (providerId, districtId) {
            var urlGet = myURL + providerId + '/hierarchylevels/GROUPS/' + districtId + '/hierarchyleafs/';
            myToken = userAuthenticateService.getUserToken();
            return commonRESTCallService.getFromServerWithToken(
                urlGet, myToken
            );
        };

        //get all regions per selected Division
        usersAPI.getDealershipsByGroup = function (providerId, groupId) {
            var urlGet = myURL + providerId + '/hierarchylevels/DEALERSHIPS/' + groupId + '/hierarchyleafs/';
            myToken = userAuthenticateService.getUserToken();
            return commonRESTCallService.getFromServerWithToken(
                urlGet, myToken
            );
        };

        usersAPI.getHierarchy = function(userId){
            var urlGet = myURL + 'hierarchylevels/useraccounts/' + userId;
            myToken = userAuthenticateService.getUserToken();
            return commonRESTCallService.getFromServerWithToken(
                urlGet, myToken
            );
        };

        usersAPI.getHierarchyDealerships = function(providerId, userId){
            var urlGet = myURLDealerships + 'provider/' + providerId + '/useraccounts/' + userId;
            myToken = userAuthenticateService.getUserToken();
            return commonRESTCallService.getFromServerWithToken(
                urlGet, myToken
            );
        };

        //assign user to a leaf
        usersAPI.postUsertoHierarchyLeaf = function (providerId, leafId, userId) {
            var urlPost = myURL + providerId + '/hierarchyleafs/' + leafId + '/useraccounts/' + userId;
            myToken = userAuthenticateService.getUserToken();
            return commonRESTCallService.postToServerWithToken(
                urlPost, null, myToken
            );
        };

        //assign user to a dealership
        usersAPI.postUsertoDealership = function (dealershipId, userId) {
            var urlPost = myURLDealerships + dealershipId + '/useraccounts/' + userId;
            myToken = userAuthenticateService.getUserToken();
            return commonRESTCallService.postToServerWithToken(
                urlPost, null, myToken
            );
        };

        //delete user from a leaf
        usersAPI.deleteUserfromHierarchyLeaf = function (providerId, leafId, userId) {
            var urlPost = myURL + providerId + '/hierarchyleafs/' + leafId + '/useraccounts/' + userId;
            myToken = userAuthenticateService.getUserToken();
            return commonRESTCallService.deleteToServerWithToken(
                urlPost, myToken
            );
        };

        //assign user to a dealership
        usersAPI.deleteUserfromDealership = function (dealershipId, userId) {
            var urlPost = myURLDealerships + dealershipId + '/useraccounts/' + userId;
            myToken = userAuthenticateService.getUserToken();
            return commonRESTCallService.deleteToServerWithToken(
                urlPost, myToken
            );
        };

        return usersAPI;
    }
]);